import { createRoot } from 'react-dom/client';
import videojs from 'videojs-mux-kit';
import PlaybackOptionsPopover from '../components/PlaybackOptionsPopover';
import createUsageTracker from './tracker';
import { getHlsTech } from './player';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoJSComponent = videojs.getComponent('Component');
class PlaybackPopover extends VideoJSComponent {
  constructor(player, options) {
    super(player, options);
    this.root = null;
    this.mount = () => {
      if (this.root) {
        return;
      }
      this.root = createRoot(this.el());
      this.root.render( /*#__PURE__*/_jsx(PlaybackOptionsPopover, {
        player: this.player(),
        hls: getHlsTech(this.player()),
        tracker: this.tracker
      }));
    };
    this.el().className = this.buildCSSClass();
    this.tracker = createUsageTracker(); // defer call until plugin setup to ensure start.ts has already called createUsageTracker with initial props

    player.ready(() => {
      this.mount();
    });
    this.on('dispose', () => {
      var _this$root;
      (_this$root = this.root) === null || _this$root === void 0 || _this$root.unmount();
      this.root = null;
    });
  }
  buildCSSClass() {
    return `vjs-playback-options vjs-menu-button vjs-menu-button-popup vjs-control vjs-button ${super.buildCSSClass()}`;
  }
}
VideoJSComponent.registerComponent('PlaybackPopover', PlaybackPopover);